import Vue from 'vue';
import Component from 'vue-class-component';
import Router from 'vue-router';
// Own components
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// External components
import Datepicker from 'vuejs-datepicker';
// Services
import AdminService from '@/core/services/admin.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker
  }
})
export default class AdminsListComponent extends Vue {

  // Service's Instance
  adminService: any = new AdminService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  modal: boolean = false;
  deleteIcon: boolean = false;
  searchCompanyFlag: boolean = false;
  searchRolFlag: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = false;
  userToDelete: any;
  searchFlag: any = [];
  reportersList: any = [];
  filterReportersList: any = [];
  companyList: any = [];
  roleList: any = [];
  name: string = "";
  search: string = "";
  company: any = [];
  companies: any = "default";
  finderCompanies: string = "default";
  role: any = [];
  roles: any = "default";
  finderRoles: string = "default";
  companyName: string = "";
  searchByDate: any = "defaultDate";
  createdAt: string = "";
  filterConcatDate: string = "";
  companyToSearch: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfAdmins: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;
  isTokenTimeOut: boolean = false;

  mounted (){
    const _ = this;
    _.getReporters();
    _.filterDate();
    _.getCompanies();
  }

  filterByDate(){
    const _ = this;
    _.deleteIcon = true;
    console.log(_.searchByDate)
    let day = _.searchByDate.getDate() < 10 ? '0' + _.searchByDate.getDate() : _.searchByDate.getDate();
    let month = _.searchByDate.getMonth() < 10 ? '0' + (_.searchByDate.getMonth() + 1) : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    if(_.finderCompanies == 'default'){
      console.log('Es default');
      _.filterReportersList = _.reportersList.filter((reporters) => {
        let parseDate: any = reporters.createdAt.split('T');
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      })
      return;
    }
    _.filterReportersList = _.reportersList.filter((reporters) => {
      let parseDate: any = reporters.createdAt.split('T');
      parseDate = parseDate[0];
      return reporters.company.name == _.finderCompanies && _.filterConcatDate == parseDate;
    })
  }

  deleteDate(){
    const _ = this;
    _.filterConcatDate = '';
    _.deleteIcon = false;
    if(_.filterConcatDate == ''){
      _.searchByDate = '';
      _.filterReportersList = _.reportersList;
      return;
    }
  }

  fiterByCompany(company){
    const _ = this;
    if(company == 'default' && _.filterConcatDate == ''){
      _.filterReportersList = _.reportersList;
      return;
    }

    if(company == 'default' && _.filterConcatDate != ''){
      _.filterReportersList = _.reportersList.filter((reporters) => {
        let parseDate: any = reporters.createdAt.split('T');
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      })
      return;
    }

    if(_.filterConcatDate != ''){
      _.filterReportersList = _.reportersList.filter((reporters) => {
        let parseDate: any = reporters.createdAt.split('T');
        parseDate = parseDate[0];
        console.log(_.filterConcatDate, ' Created');
        console.log(parseDate, ' Parse')
        return reporters.company.name == company && _.filterConcatDate == parseDate;
      })
      return;
    }
    _.filterReportersList = _.reportersList.filter((reporters) => {
      return reporters.company.name == company;
    })
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id){
    const _ = this;
    _.userToDelete = id;
    _.modal = true;
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.adminService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getReporters() {
    const _ = this;
    _.isLoading = true;
    _.adminService.getReporters().then((data: any) => {
      console.log(data['data'].reporters);
      _.filterReportersList = data['data'].reporters.filter((reporter) => {
        return reporter.role.type === 'reporter';
      });
      _.reportersList = _.filterReportersList;
      
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  delete_user(){
    const _ = this;
    _.isLoading = true;
    _.adminService.delete_user(_.userToDelete).then((data: any) => {
      _.getReporters();
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }
  //
  // nextPageAction(){
  //   const _ = this;
  //   _.itemsOfTo = (_.itemsOfTo + _.adminList.length);
  //   _.itemsOfFrom = (_.itemsOfFrom + _.adminList.length);
  //   _.pageOffset++;
  //   _.currentPage++;
  //   _.nextPage++;
  //   _.get(_.pageOffset);
  //   if(_.totalPages == _.currentPage){
  //     _.nextPositionDisabled = true;
  //     return;
  //   }
  // }
  //
  // previousPageAction(){
  //   const _ = this;
  //   if(_.currentPage == 1){
  //     return
  //   }
  //   _.itemsOfTo = _.itemsOfTo - _.adminList.length;
  //   _.itemsOfFrom = _.itemsOfFrom - _.adminList.length;
  //   _.pageOffset--;
  //   _.currentPage--;
  //   _.nextPage--;
  //   _.get(_.pageOffset);
  //
  //   if(_.totalPages != _.currentPage){
  //     _.nextPositionDisabled = false;
  //     return
  //   }
  // }
}
